import { Injectable } from '@angular/core';
import { UrlService } from '@services/url/url.service';
import { AppDispatch } from '@state/app/app.dispatch';
import { SideNavFlyoutType } from '@state/app/app.model';
import { AuthDispatch } from '@state/auth/auth.dispatch';

@Injectable({
	providedIn: 'root',
})
export class MenusService {
	constructor(
		private authDispatch: AuthDispatch,
		private appDispatch: AppDispatch,
	) {}

	getMainMenu() {
		return {
			items: [
				{
					title: {
						iconName: 'layout-dashboard',
						label: 'Dashboard',
					},
					route: UrlService.Dashboard(),
					intercom: 'home',
				},
				{
					title: {
						iconName: 'search',
						label: 'Search',
					},
					action: () => {
						this.appDispatch.OpenSideNav(SideNavFlyoutType.SEARCH);
					},
					intercom: 'search-file',
				},
				{
					title: {
						iconName: 'folders',
						label: 'All Files',
					},
					route: UrlService.View_All_Files_List(),
					intercom: 'ribbon-go-to-all-files',
				},
				{
					title: {
						iconName: 'calendar-month',
						label: 'Calendar',
					},
					route: UrlService.Calendar(),
					intercom: 'ribbon-go-to-calendar',
				},
				{
					title: {
						iconName: 'calendar-due',
						label: 'Appointments',
					},
					action: () => {
						this.appDispatch.OpenSideNav(SideNavFlyoutType.APPOINTMENTS);
					},
					intercom: 'appointments',
				},
			],
		};
	}

	getInboxMenu() {
		return {
			title: {
				label: 'INBOXES',
			},
			items: [
				{
					title: {
						iconName: 'home-dollar',
						label: 'Mortgages',
					},
					route: UrlService.MortgageInbox(),
					intercom: 'ribbon-go-to-llc-inbox',
				},
				{
					title: {
						iconName: 'shield-check',
						label: 'IDV',
					},
					route: UrlService.IDVList(),
					intercom: 'ribbon-go-to-idv-list',
				},
			],
		};
	}

	getSettingsMenu() {
		const settingsMenu = {
			title: {
				label: 'Settings',
			},
			items: [
				{
					title: {
						iconName: 'settings',
						label: 'Settings',
					},
					route: UrlService.Profile(),
					intercom: 'business-settings',
				},
				{
					title: {
						iconName: 'headset',
						label: 'Support',
					},
					action: () => {
						this.appDispatch.OpenSideNav(SideNavFlyoutType.SUPPORT);
					},
					intercom: 'support',
				},
			],
		};

		settingsMenu.items.push({
			title: {
				iconName: 'logout',
				label: 'Logout',
			},
			action: () => {
				this.authDispatch.LogOut();
			},
			intercom: 'logout',
		});

		return settingsMenu;
	}
}
